import { useCallback, useState } from 'react';

const KEY = 'v3Theme';

// The light theme is offered: a Light / Dark button in the top bar. Dark is the default. The choice is remembered in this browser (v3Theme).
export const LIGHT_ENABLED = true;

// 'dark' or 'light' for V3 only, remembered in this browser. The current site and V2 keep their own settings.
export const readMode = () => {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (ex) { /* storage blocked: use the default */ }
  return 'dark';
};

export function useV3Theme() {
  const [mode, setMode] = useState(readMode);
  const toggle = useCallback(() => {
    setMode((current) => {
      const next = current === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(KEY, next); } catch (ex) { /* not remembered */ }
      return next;
    });
  }, []);
  return [mode, toggle];
}
